<template>
  <div :class="boxClassNames"><i :class="iconClassNames" />{{ label }}</div>
</template>

<script setup>
import {computed} from 'vue';
import {useLanguage} from '@front/hooks';

const { tl } = useLanguage();

const props = defineProps({
  value: Boolean,
  trueLabel: String,
  falseLabel: String,
  trueCustomLabel: String,
  falseCustomLabel: String,
});

const boxClassNames = computed(() => (props.value ? 'n-success' : 'n-error'));
const iconClassNames = computed(() => `fas mr-1 ${props.value ? 'fa-check-circle' : 'fa-ban'}`);

const label = computed(() => {
  if (props.value) {
    return props.trueCustomLabel ?? tl(props.trueLabel);
  } else {
    return props.falseCustomLabel ?? tl(props.falseLabel);
  }
});
</script>

<script>
export default {
  name: 'NBooleanLabel',
};
</script>

<style scoped></style>
